export const BRANDING_SERVICE = Symbol.for('BRANDING_SERVICE');
